<template>
  <div class="createdCharts clearfix" v-loading.fullscreen.lock="loadingMark" element-loading-text="正在等待图表生成 ...">
    <div class="charts_header clearfix">
      <!--<div class="closediv" @click="close"><span class="close"></span></div>-->
      <div class="header_content clearfix">
        <div class="left">
          报表 {{common.timestampToTime(dataTime.getTime())}}
        </div>
        <div class="right">
          <div class="right_right">
            <div class="export" @click="exportClick()">导出</div>
            <div class="print" @click="closeView">
              <i class="el-icon-circle-close" style="color: #5087e4;font-size: 18px;margin-right: 4px;"></i>
              关闭
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="charts_content clearfix" ref="fatherPrint">
      <div class="overAuto clearfix" id="print" ref="print">
        <!--表格-->
        <div class="Table clearfix">
          <div class="tableCharts clearfix" v-for="(item,index) in tableList">
            <div class="title">
              <div class="title-border"></div>
              {{item.name}}
            </div>
            <div class="table_content" :ref="'tableList'+item.id">
              <el-table ref="multipleTable" :highlight-current-row="true" :data="item.tableData.data"
                tooltip-effect="dark" border>
                <el-table-column :label="reportData.title" min-width="761" align="center">
                  <el-table-column :label="subTitle(reportData)" min-width="761" align="right">
                    <el-table-column prop="address" width="166" label="时间">
                      <template slot-scope="scope">
                        <div style="letter-spacing: 0.5px;">{{ changeTime2(scope.row.createdTime,timeData.timeWindow)}}</div>
                      </template>
                    </el-table-column>
                    <el-table-column width="136" v-for="(itemData,index) in item.tableData.attr" :key="index+Math.random()"
                      prop="address" :label="itemData.nameA" v-if="itemData.nameA != ''">
                      <template slot-scope="scope">{{ showTableData(scope.row[itemData.nameA],itemData.unit)}}</template>
                    </el-table-column>
                    <el-table-column width="136" v-for="(itemData,index) in item.tableData.attr" :key="index+Math.random()"
                      prop="address" :label="itemData.nameB" v-if="itemData.nameB != ''">
                      <template slot-scope="scope">{{ showTableData(scope.row[itemData.nameB],itemData.nameC?itemData.unit:'%')}}</template>   <!-- ,itemData.unit -->
                    </el-table-column>
                    <el-table-column width="136" v-for="(itemData,index) in item.tableData.attr" :key="index+Math.random()"
                      prop="address" :label="itemData.nameC" v-if="itemData.nameC != ''">
                      <template slot-scope="scope">{{ showTableData(scope.row[itemData.nameC],itemData.unit)}}</template>   <!-- ,itemData.unit -->
                    </el-table-column>
                    <el-table-column min-width='1'></el-table-column>
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!-- <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="date" label="日期" width="180">
            </el-table-column>
            <el-table-column prop="nam6666666666666666e" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="address" label="地址">
            </el-table-column>
          </el-table> -->

        </div>
      </div>
    </div>
    <!--<img :src="img" id="printa" />-->
  </div>
</template>

<script>
  import html2canvas from 'html2canvas' // 转图片打印需要先安装html2Canvas和print-js
  import printJS from 'print-js'
  var XLSX = require('xlsx')
  import {
    mapState
  } from 'vuex';
  export default {
    name: 'createdCharts',
    props: {

    },
    data() {
      return {
        loadingMark: false, //loding加载开关
        dataTime: new Date(), //当前时间
        img: '',
        deviceList: [],
        reportData:{},
        timeData:{},
        beginTime:null,
        endTime:null,
        printObj: {
          id: 'printMe',
        },
        tableData: {},
        tableList:[],
        ProductFeature: [],
        dataSetArr:[],
      }
    },
    created() {
      this.$parent.ChangeHeaderShow();
      // this.reportData = JSON.parse(sessionStorage.getItem('reportData')).reportData
      this.$set(this,'reportData',JSON.parse(localStorage.getItem('reportData')).reportData)
      this.$set(this,'timeData',JSON.parse(localStorage.getItem('reportData')).timeData)
      this.reportData.dataSource = JSON.parse(this.reportData.dataSource)
      // this.timeData = JSON.parse(sessionStorage.getItem('reportData')).timeData
      this.timeData.id = this.reportData.id
      this.timeData.code = this.reportData.groupCode
      this.getDataSet()
      this.getGroup()
    },
    computed: {
      ...mapState("defaultChartsOptions", {
        system_options: 'system_options',
        ChartsDataLength: 'ChartsDataLength'
      }),
      showTableData() {
        return (value, unit) => {
          if (value == null) {
            return '-'
          } else {
            unit = unit ? unit : ''
            return this.common.fmoneyNoFix(value) + ' ' + unit
          }
        }
      },
      subTitle(){
        return (report)=>{
          let text = "",start='',end='';
          if(report.hasTime){
            start = this.changeTime2(this.beginTime,this.timeData.timeWindow)
            end =  this.changeTime2(this.endTime,this.timeData.timeWindow)
          }else if(report.hasDate){
            start = this.changeTime2(this.beginTime,this.timeData.timeWindow)
            end =  this.changeTime2(this.endTime,this.timeData.timeWindow)
          }
          text = `${start} - ${end}`
          if(report.hasGroup&&report.Groupname){
            text=report.Groupname+" "+text
          }
          return text
        }
      }
    },
    mounted() {
      let self = this;
      document.title = `报表 ${self.common.timestampToTime(self.dataTime.getTime())}`; // 动态修改网站标题
    },
    components: {
    },
    methods: {
      // 关闭页面
      closeView(){
        window.close()
      },
      // 获取数据集
      async getDataSet(){
        for(let i in this.reportData.dataSource){
          let item = this.reportData.dataSource[i]
          if(item.type==7){
            await this.get("/v2/Dataset/get",{id:item.extend}).then(res=>{
              if(res.success){
                this.dataSetArr.push(res.result)
              }
            })
          }
          if(i==this.reportData.dataSource.length-1){
            this.initData()
          }
        }
      },
      // 获取组织
      getGroup(){
        if(this.reportData.groupCode.slice(0,1)=='E'){
          this.get('/Company/get',{code:this.reportData.groupCode}).then(res=>{
            if(res.success){
              this.reportData.Groupname = res.result[0].shortName
            }
          })
        }else{
          this.get('/Group/get',{code:this.reportData.groupCode}).then(res=>{
            if(res.success){
              this.reportData.Groupname = res.result.name
            }
          })
        }
      },
      // 获取数据
      initData(){
        this.get('/Report/getData',this.timeData).then(async res=>{
          if(res.success){
            // console.log(this.reportData.place,this.reportData.unit,this.reportData.unitName)
            this.beginTime = res.result.start
            this.endTime = res.result.end
            // 获取设备模型 key设置成设备名 数据存到key为设备名的数组中，
            let arr = [],timeArr=[],i=0,dataArr=[]
            for(let item of res.result.data){
              if(item.data.length){
                item.data.sort((a,b)=>{
                  return a.time - b.time
                })
              }
            }
            let timeData = res.result.data.filter(item=>item.data.length)[0]
            if(timeData){
             for(let time of timeData.data){
               timeArr.push(time.time)
             }
            }
            arr.push({key:"time",time:timeArr})
            let Objreturn = await this.TableGetByDeviceCode({}, res.result.data, 1, this.reportData.place);
            this.tableList = [
              {tableData:Objreturn,id:1,title:this.reportData.title}
            ]
            // for(let item of res.result){
            //   let device = await this.getProductFeature(item.deviceCode,item.propertyCode)
            // }
          }else{
            this.$message({
              message: `获取报表数据失败:${res.message}`,
              type: 'warning'
            });
          }
        })
      },
      initTable() {
        let self = this;
        return new Promise(resolve => {
          if (this.tableList.length == 0) {
            resolve();
            return;
          }
          let listIndex = 0;
          for (let obj of this.tableList) {
            //初始化表格
            obj.tableData = {
              attr: [],
              data: [],
            };
            /*
             * 表格 可以有多条数据源 即多个tableData.attr	时间一致
            	obj => 数据集对象 选中的数据集图表类型为文本标签
             */
              var ratio = 1;
            //保留小数
            if (obj.place) {
              var place = obj.place
            } else {
              var place = null;
            }

            var attr = [];
            var data = [];
            /*获取数据集历史数据*/
            self.get('/Dataset/getReport', {
              id: obj.id, //数据集编号
              code: obj.groupCode //分组或企业编码
            }).then(async (res) => {
              if (res.success == true) {
                if (JSON.stringify(res.result) == '{}') {
                  listIndex++;
                  if (listIndex == self.tableList.length) {
                    resolve();
                  }
                } else {
                  let Objreturn = await self.TableGetByDeviceCode({}, res.result, ratio, place);
                  attr = Objreturn.attr;
                  data = Objreturn.data;
                  obj.tableData = {
                    attr: attr,
                    data: data
                  }
                  listIndex++;
                  if (listIndex == self.tableList.length) {
                    resolve();
                  }
                }

              } else {
                resolve();
              }
            })
          }
        })
      },

      changeTime2(now, type) {
        if (now == "" || now == null || typeof now == 'string') {
          return
        }
        now = new Date(Number(now))
        let year = now.getFullYear(); //取得4位数的年份
        let month = now.getMonth() + 1; //取得日期中的月份，其中0表示1月，11表示12月
        let date = now.getDate(); //返回日期月份中的天数（1到31）
        let hour = now.getHours(); //返回日期中的小时数（0到23）
        let minute = now.getMinutes(); //返回日期中的分钟数（0到59）
        let seconds = now.getSeconds(); //返回日期中的分钟数（0到59）
        if (month < 10) {
          month = "0" + month
        }
        if (date < 10) {
          date = "0" + date
        }
        if (hour < 10) {
          hour = "0" + hour
        }
        if (minute < 10) {
          minute = "0" + minute
        }
        if (seconds < 10) {
          seconds = "0" + seconds
        }
        switch(type){
          case 0 :
            return `${year}-${month}-${date} ${hour}:${minute}:${seconds}`
            break;
          case 1 :
            return `${year}-${month}-${date} ${hour}:${minute}`
            break;
          case 2 :
            return `${year}-${month}-${date} ${hour}`
            break;
          case 3 :
            return `${year}-${month}-${date}`
            break;
          case 5 :
            return `${year}-${month}`
            break;
          case 7 :
            return `${year}`
            break;
          default :
            return `${year}-${month}-${date} ${hour}:${minute}:${seconds}`
            break;
        }
      },

      /*通过 设备Code/属性code 获取物模型对象*/
      // getProductFeature(deviceCode, propertyCode) {
      //   /* 同步
      //    * deviceCode => 设备code
      //    * propertyCode => 属性code
      //    * 返回物模型对象和设备名
      //    * */
      //   let self = this;
      //   return new Promise((resolve) => {
      //     let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
      //     if (FeatureArr.length == 0) {
      //       self.get('/Device/getByCode',{code:deviceCode}).then(resDev=>{
      //         if(resDev.success){
      //           self.get('/ProductFeature/getByDeviceCode', {
      //             code: deviceCode, //设备code
      //           }).then((resPro) => {
      //             if (resPro.success == true) {
      //               let dataList = JSON.parse(resPro.result).properties;
      //               self.ProductFeature.push({
      //                 deviceName:resDev.result.name,
      //                 property:dataList.filter(item => item.identifier == propertyCode)[0],
      //                 propertyName:dataList.filter(item => item.identifier == propertyCode)[0].name,
      //                 unit:dataList.filter(item => item.identifier == propertyCode)[0].dataType.specs.unit,
      //               })
      //               let obj = {
      //                   deviceName:resDev.result.name,
      //                   property:dataList.filter(item => item.identifier == propertyCode)[0],
      //                   propertyName:dataList.filter(item => item.identifier == propertyCode)[0].name,
      //                   unit:dataList.filter(item => item.identifier == propertyCode)[0].dataType.specs.unit,
      //               }
      //               resolve(obj)
      //               return;
      //             }else{
      //               resolve({})
      //             }
      //           })
      //         }else{
      //           this.$message({
      //             message: `获取设备数据失败:${res.message}`,
      //             type: 'warning'
      //           })
      //         }
      //       })

      //     } else {
      //       resolve(FeatureArr[0])
      //       return;
      //     }
      //   })
      // },
      getProductFeature(deviceCode, propertyCode) {
        /* 同步
         * deviceCode => 设备code
         * propertyCode => 属性code
         * 返回物模型对象
         * */
        let self = this;
        return new Promise((resolve) => {
          let FeatureArr = self.ProductFeature.filter(item => item.deviceCode == deviceCode)
          if (FeatureArr.length == 0) {
            self.get('/ProductFeature/getByDeviceCode', {
              code: deviceCode, //设备code
            }).then((resPro) => {
              if (resPro.success == true) {
                let dataList = JSON.parse(resPro.result).properties;
                self.ProductFeature.push({
                  deviceCode: deviceCode,
                  properties: dataList
                })
                resolve(dataList.filter(item => item.identifier == propertyCode)[0])
                return;
              }
            })
          } else {
            resolve(FeatureArr[0].properties.filter(item => item.identifier == propertyCode)[0])
            return;
          }
        })
      },
      /*通过 设备Code/属性code 获取物模型对象*/
      getDevice(deviceCode) {
        /* 同步
         * deviceCode => 设备code
         * 返回设备名称
         * */
        let self = this;
        return new Promise((resolve) => {
          if (!deviceCode) {
            resolve('')
            return;
          }
          let device = self.deviceList.filter(item => item.code == deviceCode)
          if (device.length == 0) {
            self.get('/Device/getByCode', {
              code: deviceCode, //设备code
            }).then((resPro) => {
              if (resPro.success == true) {
                let obj = resPro.result;
                self.deviceList.push(obj)
                resolve(obj.name)
                return;
              } else {
                resolve('')
                return;
              }
            })
          } else {
            resolve(device[0].name)
            return;
          }
        })
      },

      /*通过产品Code获取产品对象*/
      getProductByCode(code) {
        /* 同步
         * code => 产品code
         * 返回产品对象名称
         * */
        let self = this;
        return new Promise((resolve) => {
          self.get('/Product/getList').then((resPro) => {
            if (resPro.success == true) {
              let obj = resPro.result.filter(item => item.code == code)[0];
              if (!obj) {
                resolve('')
              } else {
                resolve(obj.name);
              }
            }
          })
        })
      },

      /*表格 解决异步问题 调用产品物模型*/
      TableGetByDeviceCode(obj, resultD, ratio, place) {
        /*
         * obj => 当前数据集对象
         * resultD => 当前数据集历史记录单个对象
         * ratio => 当前数据集修正系数
         * place => 当前数据集保留小数位数
         */
        let self = this;
        return new Promise(async (resolve) => {
          let data = [];
          let attr = [];
          /*没数据的情况下*/
          if (JSON.stringify(resultD) == '[]' || JSON.stringify(resultD) == '{}') {
            resolve({
              attr: [],
              data: []
            })
            return;
          }
          let index = 0;
          for (let result of resultD) {
            let featureList;
            let unit = this.reportData.unit;
            let nameA = '';
            let nameB = '';
            let nameC = '';
            let name = '';
            if (result.deviceCode == 'SYSTEM_PROPERTY') {
              /*判断数据集历史记录的单个对象是否为系统属性*/
              // unit = '';
              if (result.propertyCode.indexOf('_alarm_category_') != -1) {
                name = await self.getDictById(result.propertyCode.split('_alarm_category_')[1]);
              } else if (result.propertyCode.indexOf('_device_product_') != -1) {
                name = await self.getProductByCode(result.propertyCode.split('_device_product_')[1]);
              } else {
                name = self.system_options.filter(item => item.id == result.propertyCode)[0].name;
              }
            } else if(!result.deviceCode){
              name = result.name
              let dataSet = this.dataSetArr.find(item =>item.name==name)
              if(dataSet){
                unit = dataSet.unit
                place = dataSet.place
              }
            } else {
              /*不为系统属性时*/
              /*获取TSL 获取 数据属性名称*/
              featureList = await self.getProductFeature(result.deviceCode, result.propertyCode);
              let deviceName = await self.getDevice(result.deviceCode);
              name = deviceName ? featureList.name + '/' + deviceName : featureList.name;
              unit = featureList.dataType.specs.unit
              let match = featureList.dataType.specs.step||featureList.dataType.specs.step==0?featureList.dataType.specs.step.match(/\.(\d+)/):null;
              if (match){
                place = match[1].length;
              } else {
                place = 0;
              }
            }
            if (!unit) {
              unit = '';
            }
            // 241223 需求更改
            // console.log(name)
            // nameA = result.name?result.name+'/'+name:name
            nameA=name
            let length = 0
            if(result.data.length){
              result.data.forEach((item)=>{
                if(item.value.length>length){
                  length=item.value.length
                }
              })
            }
            if(length==2){
              nameB = nameA + ' (增长率)'
              nameA = nameA + ' (增长量)'
            }else if(length==3){
              nameC = nameA + ' (平均)'
              nameB = nameA + ' (最小)'
              nameA = nameA + ' (最大)'
            }
            attr.push({
              nameA: nameA,
              nameB: nameB,
              nameC: nameC,
              unit: unit
            })
            /*如果是第一次进入 则在data创建新对象 如果是n次进入 则将值直接添加进已创建的data对象中*/
            if (index == 0) {
              for (let resultData of result.data) {
                let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                let obj = {};
                obj.createdTime = resultData.time;
                for (let valueList of resultData.value) {
                  if (nameIndex == 0) {
                    if (valueList == null) {
                      obj[nameA] = null;
                    } else {
                      obj[nameA] = (valueList * ratio).toFixed(place)
                    }
                  } else if (nameIndex == 1) {
                    if (valueList == null) {
                      obj[nameB] = null
                    } else {
                      // obj[nameB] = (valueList * ratio).toFixed(place)
                      obj[nameB] = nameC?(valueList * ratio).toFixed(place):(valueList * ratio * 100).toFixed(place)
                    }
                  } else if (nameIndex == 2) {
                    if (valueList == null) {
                      obj[nameC] = null
                    } else {
                      obj[nameC] = (valueList * ratio).toFixed(place)
                    }
                  }
                  nameIndex++;
                }
                data.push(obj);
              }
            } else {
              for (let resultData of result.data) {
                // for(let NowData of data) {
                // 	if(NowData.createdTime == resultData.time) {
                // 		let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                // 		for(let valueList of resultData.value) {
                // 			if(nameIndex == 0) {
                // 				if(valueList == null){
                // 					NowData[nameA] = null;
                // 				}else{
                // 					NowData[nameA] = (valueList * ratio).toFixed(place);
                // 				}
                // 			} else if(nameIndex == 1) {
                // 				if(valueList == null){
                // 					NowData[nameB] = null;
                // 				}else{
                // 					NowData[nameB] = (valueList * ratio).toFixed(place);
                // 				}
                // 			} else if(nameIndex == 2) {
                // 				if(valueList == null){
                // 					NowData[nameC] = null;
                // 				}else{
                // 					NowData[nameC] = (valueList * ratio).toFixed(place);
                // 				}
                // 			}
                // 			nameIndex++;
                // 		}
                // 	}
                // }
                let NowData = data.filter(i => i.createdTime == resultData.time)[0]
                if (NowData) {
                  let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                  for (let valueList of resultData.value) {
                    if (nameIndex == 0) {
                      if (valueList == null) {
                        NowData[nameA] = null;
                      } else {
                        NowData[nameA] = (valueList * ratio).toFixed(place);
                      }
                    } else if (nameIndex == 1) {
                      if (valueList == null) {
                        NowData[nameB] = null;
                      } else {
                        // NowData[nameB] = (valueList * ratio).toFixed(place);
                        NowData[nameB] = nameC?(valueList * ratio).toFixed(place):(valueList * ratio * 100).toFixed(place)
                      }
                    } else if (nameIndex == 2) {
                      if (valueList == null) {
                        NowData[nameC] = null;
                      } else {
                        NowData[nameC] = (valueList * ratio).toFixed(place);
                      }
                    }
                    nameIndex++;
                  }
                } else {
                  NowData = {}
                  NowData.createdTime = resultData.time
                  let nameIndex = 0; //为了赋予函数后缀名而创建的索引
                  for (let valueList of resultData.value) {
                    if (nameIndex == 0) {
                      if (valueList == null) {
                        NowData[nameA] = null;
                      } else {
                        NowData[nameA] = (valueList * ratio).toFixed(place);
                      }
                    } else if (nameIndex == 1) {
                      if (valueList == null) {
                        NowData[nameB] = null;
                      } else {
                        // NowData[nameB] = (valueList * ratio).toFixed(place);
                        NowData[nameB] = nameC?(valueList * ratio).toFixed(place):(valueList * ratio * 100).toFixed(place)
                      }
                    } else if (nameIndex == 2) {
                      if (valueList == null) {
                        NowData[nameC] = null;
                      } else {
                        NowData[nameC] = (valueList * ratio).toFixed(place);
                      }
                    }
                    nameIndex++;
                  }
                  data.push(NowData);
                }
              }
            }
            index++;
            if (index == resultD.length) {
              resolve({
                attr: attr,
                data: data
              })
            }
          }
        })

      },

      /*格式化数据*/
      randomData(unit, now, value) {
        if (value == null) {
          value = [
            now,
            '-'
          ]
        } else {
          value = [
            //时间戳转时间的string 格式 => "1998/1/13" ; getMonth() + 1是为了去掉开头部分
            now,
            //该时间下的值
            value
          ]
        }
        now = this.common.timestampToTime(now);
        return {
          name: now,
          value: value,
          unit: unit,
        };
      },
      /*数字格式化
       s => 值
       n => 设置n个值时用逗号隔开
       * */
      fmoney(s, n) {
        let minus = false; //判断是否为负数
        n = n > 0 && n <= 20 ? n : 2;
        if (Number(s) < 0) {
          minus = true
          s = Number(String(s).split('-')[1])
        }
        s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
        var l = s.split(".")[0].split("").reverse(),
          r = s.split(".")[1];
        var t = "";
        for (let i = 0; i < l.length; i++) {
          t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
        }
        if (minus) {
          return '-' + t.split("").reverse().join("") + "." + r;
        } else {
          return t.split("").reverse().join("") + "." + r;
        }
      },

      /*导出*/
      exportClick() {
        // 创建表格
        var wb = XLSX.utils.book_new();
        for (let item of this.tableList) {
          let titleArr = ['时间'],
            dataArr = []
          for (let title of item.tableData.attr) {
            title.nameA && titleArr.push(title.nameA)
            title.nameB && titleArr.push(title.nameB)
            title.nameC && titleArr.push(title.nameC)
          }
          for (let attr of item.tableData.data) {
            let valuearr = []
            for (var i in titleArr) {
              if (titleArr[i] == '时间') {
                valuearr[0] = this.changeTime2(attr['createdTime'], this.timeData.timeWindow)
              } else {
                valuearr[i] = attr[titleArr[i]] || ''
              }
            }
            dataArr.push(valuearr)
          }
          let titleArr2 = ['时间']
          for (let title of item.tableData.attr){
            title.nameA && titleArr2.push(title.unit ? title.nameA + '(' + title.unit + ')' : title.nameA)
            // title.nameB && titleArr2.push(title.nameB)
            // title.nameC && titleArr2.push(title.nameC)
            title.nameB && titleArr2.push(title.unit ? title.nameB + '(' + `${title.nameC?title.unit:'%'}` + ')' : title.nameB)
            title.nameC && titleArr2.push(title.unit ? title.nameC + '(' + title.unit + ')' : title.nameC)
          }
          dataArr.unshift(titleArr2)
          dataArr.unshift([this.subTitle(this.reportData)])
          dataArr.unshift([this.reportData.title])
          var obj = {
            name: this.reportData.title,
            dataArr: dataArr,
          }
          console.log(dataArr)
          var ws = XLSX.utils.aoa_to_sheet(dataArr);
          XLSX.utils.book_append_sheet(wb, ws, item.name);
        }
        XLSX.writeFile(wb, this.changeTime(new Date().getTime()) + '.xlsx');
      },
      /*打印*/
      printClick() {
        // 转图片打印
        let that = this;
        var canvas2 = document.createElement("canvas");
        // let _canvas = document.getElementById('child');
        let _canvas = this.$refs.fatherPrint;
        var w = parseInt(window.getComputedStyle(_canvas).width);
        var h = parseInt(window.getComputedStyle(_canvas).height);
        //将canvas画布放大若干倍，然后盛放在较小的容器内，就显得不模糊了
        canvas2.width = w;
        canvas2.height = h;
        canvas2.style.width = w + "px";
        canvas2.style.height = h + "px";
        //可以按照自己的需求，对context的参数修改,translate指的是偏移量
        var context = canvas2.getContext("2d");
        //				context.scale(5, 5);
        html2canvas(this.$refs.fatherPrint, {
          canvas: canvas2
        }).then(function(canvas) {
          const url = canvas.toDataURL()
          //					console.log(url)
          printJS({
            printable: url,
            type: 'image',
            documentTitle: '打印图片'
          })
        });
        /*let top = this.$refs.fatherPrint.scrollTop;
        this.$refs.fatherPrint.scrollTop = 0

        html2canvas(this.$refs.print, {
        	backgroundColor: '#fff',
        	useCORS: true,
        	windowHeight: this.$refs.print.offsetHeight
        }).then((canvas) => {
        	//拍照之后 再打印
        	//let url = canvas.toDataURL('image/jpeg', 1.0)
        	const url = canvas.toDataURL()
        	this.img = url;
        	this.$nextTick(() => {
        		this.$print(document.getElementById('printa'))
        		this.$refs.fatherPrint.scrollTop = top;
        	})
        })*/
      },

    }
  }
</script>

<style scoped>
  .table_content>>>.el-table__body {
    width: 100% !important;
  }

  /*滚动条样式：谷歌浏览器下*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #FAFAFA;
  }

  /*滚动条的滑块按钮*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #C2C2C2;
    /*box-shadow: inset 0 0 5px #000;*/
  }

  /*滚动条的上下两端的按钮*/

  .table_content>>>.el-table__body-wrapper::-webkit-scrollbar-button {
    height: 0px;
    width: 0px;
    /*background-color: #B0AEDA;*/
  }

  .overAuto {
    width: 100%;
    height: auto;
    margin-top: 20px;
  }

  .table_content>>>.el-table .has-gutter tr,
  .table_content>>>.el-table .has-gutter th {
    /* background-color: #eee !important; */
    font-weight: 500;
    color: #2B2B2B;
  }

  .table_content>>>.el-table {
    border: 1px solid rgba(228, 228, 228, 1);
    border-radius: 5px;
    border-bottom: 0;
  }

  .table_content {
    float: left;
    width: 100%;
    /*height: calc(100% - 47px);*/
    /*margin-top: 20px;*/
  }

  .fig_content {
    float: left;
    width: 100%;
    height: calc(100% - 50px);
  }

  .title .title-border {
    width: 1px;
    height: 13px;
    position: absolute;
    left: 0;
    top: 0px;
    bottom: 0;
    margin: auto;
    border-left: 4px solid #00CCCD;
  }

  .title {
    float: left;
    width: 100%;
    text-indent: 14px;
    position: relative;
    line-height: 47px;
    /*font-weight: bold;*/
    font-family: 'MicrosoftYaHei';
    margin-bottom: 20px;
  }

  .tableCharts {
    float: left;
    width: calc(100% - 75px);
    /* height: 346px; */
    color: #2C2C2C;
    font-size: 15px;
    text-align: left;
    margin-bottom: 20px;
    margin-left: 38px;
    page-break-after: always
  }

  .pielist {
    width: calc(50% - 76px) !important;
  }

  .figCharts:nth-child(even) {
    width: calc(100% - 76px);
    float: left;
    /* margin-right: 78px; */
    height: 325px;
    color: #2C2C2C;
    font-size: 15px;
    text-align: left;
    margin-left: 38px;
    page-break-after: always;
    margin-right: 38px;
    margin-bottom: 20px;
  }

  .figCharts:nth-child(odd) {
    float: left;
    width: calc(100% - 76px);
    height: 325px;
    color: #2C2C2C;
    font-size: 15px;
    text-align: left;
    margin-left: 38px;
    page-break-after: always;
    margin-right: 38px;
    margin-bottom: 20px;
  }

  .Figure,
  .Table {
    width: 100%;
    /*height: calc(100% - 144px);*/
    float: left;
    /*margin-top: 20px;*/
    page-break-after: always
  }

  .charts_content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: #f5f7fa;
  }

  /*滚动条的轨道*/

  .charts_content::-webkit-scrollbar-track {
    /*box-shadow: inset 0 0 5px rgba(0,0,0,.3);*/
    background-color: #eee;
  }

  /*滚动条的滑块按钮*/

  .charts_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #D2D2D2;
    /*box-shadow: inset 0 0 5px #000;*/
    /*box-shadow: 8px 0 0 #A5ADB7 inset;*/
  }

  /*滚动条的上下两端的按钮*/

  .charts_content::-webkit-scrollbar-button {
    height: 10px;
    background-color: #eee;
  }

  .charts_content {
    /*width: 21cm;
		position: relative;
		overflow-y: auto;
		overflow-x: hidden;
		left: 0;
		right: 0;
		margin: auto;
		background: #fff;
		min-height: 29.7cm;*/
    width: 21cm;
    position: absolute;
    /* overflow-y: auto; */
    /* overflow-x: hidden; */
    left: 0;
    right: 0;
    margin: auto;
    background: #fff;
    min-height: 29.7cm;
    top: 76px;
  }

  .print {
    display: flex;
    align-items: center;
    /* background: url(../../assets/image/createdExecl/print.png)no-repeat left; */
  }

  .export {
    background: url(../../assets/image/createdExecl/export.png)no-repeat left;
    margin-right: 23px;
  }

  .export,
  .print {
    cursor: pointer;
    width: 48px;
    text-align: right;
    float: left;
  }

  .header_content .right .right_right {
    float: left;
    color: #5087E4;
  }

  .header_content .right .right_left {
    float: left;
    margin-right: 85px;
  }

  .header_content .left {
    float: left;
    color: #363636;
    font-size: 14px;
    margin-left: 53px;
  }

  .header_content .right {
    float: right;
    padding-right: 126px;
    font-size: 13px;
  }

  .header_content {
    width: 100%;
    float: left;
    text-align: left;
  }

  #createdCharts_header_right>>>.el-radio__inner::after {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #5087E4;
    border: 1px solid #fff;
  }

  #createdCharts_header_right>>>.el-radio__input.is-checked .el-radio__inner {
    background: #5087E4 !important;
    border-color: #5087E4 !important;
  }

  #createdCharts_header_right>>>.el-radio__inner {
    border: 2px solid rgba(191, 191, 191, 1);
    width: 16px;
    height: 16px;
  }

  #createdCharts_header_right>>>.el-radio__input.is-checked+.el-radio__label {
    color: #373737 !important;
  }

  .header_content .right {
    text-align: left;
  }

  .createdCharts .charts_header {
    width: 100%;
    height: 75px;
    float: left;
    border-bottom: 1px solid #D8D8D8;
    line-height: 75px;
    background: #fff;
  }

  .createdCharts {
    width: 100%;
    /*height: 100%;*/
    position: relative;
    background-color: #eee;
  }

  .charts_header .closediv {
    float: right;
    position: relative;
    margin-right: 25px;
    margin-top: 12px;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
  }

  .charts_header .close {
    position: absolute;
    width: 0.2em;
    height: 1.3em;
    background: #777777;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    display: inline-block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }

  .charts_header .close:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0.2em;
    height: 1.3em;
    background: #777777;
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  * {
    -webkit-touch-callout: none;
    /*系统默认菜单被禁用*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -khtml-user-select: none;
    /*早期浏览器*/
    -moz-user-select: none;
    /*火狐*/
    -ms-user-select: none;
    /*IE10*/
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReportForms/ReportForms.vue